/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} Action_Bar_Unseated_NoticeInputs */



/**
* | output |
* | --- |
* | "Checked in but not seated: {names}. Seat them at a table with room, or wait for the next round." |
*
* @param {Action_Bar_Unseated_NoticeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const action_bar_unseated_notice = /** @type {((inputs: Action_Bar_Unseated_NoticeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Bar_Unseated_NoticeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Pointés mais pas placés : ${i?.names}. Placez-les à une table qui a de la place, ou attendez la ronde suivante.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Con check-in pero sin mesa: ${i?.names}. Siéntelos en una mesa con sitio, o espere a la ronda siguiente.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Com check-in mas sem mesa: ${i?.names}. Coloque-os numa mesa com vaga, ou espere a próxima rodada.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Con check-in ma senza posto: ${i?.names}. Falli sedere a un tavolo con spazio, o aspetta il round dopo.`)
	return /** @type {LocalizedString} */ (`Checked in but not seated: ${i?.names}. Seat them at a table with room, or wait for the next round.`)
});